export const isSelected = (option, selectedValue, isMultiSelect, caseSensitive) => {
    if (selectedValue !== null && selectedValue !== undefined && option.value !== undefined) {
        if (isMultiSelect) {
            return Boolean(Array.isArray(selectedValue) && selectedValue.includes(option.value));
        }
        if (caseSensitive) {
            return Boolean(selectedValue === option.value);
        }
        return Boolean(selectedValue.toLocaleString().toLocaleLowerCase() ===
            option.value.toLocaleString().toLocaleLowerCase());
    }
    return false;
};
export const getOptionVariant = (highlighted, hightlightedOptionVariant, optionVariant) => {
    return highlighted && hightlightedOptionVariant ? hightlightedOptionVariant : optionVariant;
};
export const keyUpMove = (prevFocus) => {
    let newFocus = Math.max(prevFocus, 0);
    if (prevFocus > 0) {
        newFocus -= 1;
    }
    return newFocus;
};
export const keyDownMove = (options) => (prevFocus) => {
    let newFocus = Math.max(prevFocus, 0);
    if (prevFocus + 1 <= options.length - 1) {
        newFocus += 1;
    }
    return newFocus;
};
export const getLabelCharsHighlighted = (optionValue, selectedValue, charsHighlighted) => {
    if (!selectedValue) {
        return charsHighlighted;
    }
    return optionValue === selectedValue ? charsHighlighted : undefined;
};
//# sourceMappingURL=listOptions.utils.js.map